/**
 * Figma Design Tokens
 *
 * Color tokens extracted from Figma export (ai-docs/Agrokoll_ MASTER/src/styles/globals.css)
 * These tokens provide a comprehensive color system for:
 * - Status indicators (error, warning, info, success)
 * - Validity periods (short, 1year, 3year, 5year, indefinite)
 * - Inspector theme (wine red palette)
 */

export const figmaTokens = {
  // Status colors for alerts and notifications
  status: {
    error: {
      main: 'rgba(183, 56, 49, 1.00)',
      bg: 'rgba(254, 242, 242, 1.00)',
    },
    warning: {
      main: 'rgba(245, 158, 11, 1.00)',
      bg: 'rgba(255, 251, 235, 1.00)',
    },
    info: {
      main: 'rgba(120, 90, 70, 1.00)',
      bg: 'rgba(250, 248, 246, 1.00)',
    },
    success: {
      main: 'rgba(22, 163, 74, 1.00)',
      bg: 'rgba(240, 253, 244, 1.00)',
    },
  },

  // Inspector theme - wine red color palette
  // Used for inspector-specific views and actions
  inspector: {
    primary: {
      main: 'rgba(125, 74, 74, 1.00)',
      foreground: 'rgba(255, 255, 255, 1.00)',
    },
    accent: {
      main: 'rgba(139, 90, 90, 1.00)',
      foreground: 'rgba(255, 255, 255, 1.00)',
    },
  },

  // Typography scale from Figma
  typography: {
    h1: '32px',
    h2: '22px',
    h3: '18px',
    h4: '16px',
    base: '16px',
    label: '14px',
  },

  // Font weights
  fontWeight: {
    medium: 500,
    normal: 400,
  },

  // Border radius tokens
  radius: {
    default: '16px',
    button: '24px',
    input: '8px',
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '24px',
  },

  // Elevation/Shadow
  elevation: {
    sm: '0px 4px 30px 0px rgba(0, 0, 0, 0.05)',
  },
} as const;

/**
 * Helper function to get status color tokens
 */
export function getStatusColorTokens(statusType: 'error' | 'warning' | 'info' | 'success') {
  return figmaTokens.status[statusType];
}

/**
 * Type definitions for better TypeScript support
 */
export type StatusType = 'error' | 'warning' | 'info' | 'success';
